import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import Header from './components/Header';
import Home from './components/Home';
import Haircut from './components/Haircut';
import HairColour from './components/HairColour';
import HairTreatment from './components/HairTreatment';
import PartyMakeup from './components/PartyMakeup';
import BeardStyling from './components/BeardStyling';
import BridalHairMakeup from './components/BridalHairMakeup';
import GalleryPage from './components/GalleryPage';
import HairStylesGallery from './components/HairStylesGallery';
import MakeupGallery from './components/MakeupGallery';
import BridalGallery from './components/BridalGallery';
import MensGroomingGallery from './components/MensGroomingGallery';
import BeforeAfterGallery from './components/BeforeAfterGallery';
import SalonInteriorGallery from './components/SalonInteriorGallery';
import StoreLocator from './components/StoreLocator';
import Footer from './components/Footer';
import SocialSidebar from './components/SocialSidebar';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <div className="App">
      <Header />
      <SocialSidebar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/haircut" element={<Haircut />} />
        <Route path="/hair-colour" element={<HairColour />} />
        <Route path="/hair-treatment" element={<HairTreatment />} />
        <Route path="/party-makeup" element={<PartyMakeup />} />
        <Route path="/beard-styling" element={<BeardStyling />} />
        <Route path="/bridal-hair-makeup" element={<BridalHairMakeup />} />
        <Route path="/gallery" element={<GalleryPage />} />
        <Route path="/gallery/hair-styles" element={<HairStylesGallery />} />
        <Route path="/gallery/makeup" element={<MakeupGallery />} />
        <Route path="/gallery/bridal" element={<BridalGallery />} />
        <Route path="/gallery/mens-grooming" element={<MensGroomingGallery />} />
        <Route path="/gallery/before-after" element={<BeforeAfterGallery />} />
        <Route path="/gallery/salon-interior" element={<SalonInteriorGallery />} />
        <Route path="/store-locator" element={<StoreLocator />} />
      </Routes>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
